module.exports = __webpack_public_path__ + "img/fabio.3b4ec579.png";